import React from 'react';
import withTermsPostQuery from 'utils/withTermsPostQuery';

const ProjektiDefault = (props) => {
  const PageWithTermsPost = withTermsPostQuery(
    'projekti',
    [
      'projekti_tags',
      'projektu_joma',
      'projektu_statuss',
    ],
    props.lang,
    [
      'notikusi_kluda',
      'iestade',
      'publicets',
      'dokumenti',
      'iesniegsanas_termins',
      'iesniedzejs',
      'atjaunots',
      'iepirkumi',
      'piezimes',
      'lapas',
      'kontakti',
      'tel',
      'fakss',
    ]
  );
  return <PageWithTermsPost {...props} />
}

export default ProjektiDefault;



// WEBPACK FOOTER //
// ./src/components/ProjektiDefault.js